(function() {
    'use strict';
    angular
        .module('valueconnectApp')
        .factory('VCUser', VCUser);

    VCUser.$inject = ['$resource'];

    function VCUser ($resource) {
        var resourceUrl =  'api/vc-users/:id';

        return $resource(resourceUrl, {}, {
            'query': {method: 'GET', isArray: true},
            'getOneCCR': {method: 'GET', url: 'api/vc-users/:id', isArray: false},
            'getVCUsers': {method: 'GET', url: 'api/vc-users/all', isArray: true},
            'queryCCRs': {method: 'GET', url: 'api/vc-users/ccrs', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
